<template lang="html">
	<vs-card>
		<div class="vx-row">
			<div class="vx-col w-1/2 mt-5">
				<span class="text-sm"> Período Inicial </span>
				<datepicker
					v-model="startedAt"
					name="startedAt"
					placeholder="Início do Período"
					:language="ptBR"
				></datepicker>
			</div>
			<div class="vx-col w-1/2 mt-5">
				<span class="text-sm"> Período Final </span>
				<datepicker
					v-model="finishedAt"
					name="finishedAt"
					placeholder="Fim do Período"
					:language="ptBR"
				></datepicker>
			</div>
		</div>
		<div class="vx-row justify-end mb-7">
			<div class="vx-col w-1/2 mt-5 pt-4 flex-row-reverse">
				<div class="w-full flex justify-end">
					<vs-button @click="changeFilter"> Pesquisar </vs-button>
				</div>
			</div>
		</div>
		<div v-if="totalSum" class="vx-row mt-4 ml-1">
			<!-- eslint-disable-next-line vue/no-parsing-error -->
			<span class="font-bold text-sm">Total:&nbsp</span>
			<span class="text-sm">R$ {{ formatMoney(totalSum) }}</span>
		</div>
		<div class="vx-row">
			<div class="vx-col w-full mt-3">
				<vue-good-table
					ref="my-table"
					mode="remote"
					:pagination-options="{
						enabled: true,
						nextLabel: 'próximo',
						prevLabel: 'anterior',
						rowsPerPageLabel: 'Registros por páginas',
						ofLabel: 'de',
						pageLabel: 'página',
						dropdownAllowAll: false,
					}"
					style-class="vgt-table"
					:total-rows="totalRecords"
					:columns="columns"
					:rows="rows"
					:is-loading.sync="isLoading"
					:sort-options="{
						enabled: false,
					}"
					@on-page-change="onPageChange"
					@on-column-filter="onColumnFilter"
					@on-per-page-change="onPerPageChange"
				>
					<div slot="emptystate">
						Nenhum registro encontrado.
					</div>
					<template slot="table-row" slot-scope="props">
						<span v-if="props.column.field == 'amount'">
							<span>R$ {{ formatMoney(props.row.amount) }}</span>
						</span>
						<span v-else-if="props.column.field == 'identity'">
							<span>{{
								formatIdentity(props.row.identity)
							}}</span>
						</span>
						<span v-else-if="props.column.field == 'account'">
							<span>{{ formatAccount(props.row.account) }}</span>
						</span>
						<span v-else-if="props.column.field == 'effective_at'">
							<span>{{
								formatDate(props.row.effective_at)
							}}</span>
						</span>
						<span v-else>
							{{ props.formattedRow[props.column.field] }}
						</span>
					</template>
				</vue-good-table>
			</div>
		</div>
		<div class="vx-row">
			<div class="w-full mr-4 mt-5 flex justify-end items-center">
				<div class="flex flex-col items-center">
					<span class="font-bold mb-2 text-sm">Exportar</span>
					<div class="flex">
						<vs-button
							color="primary"
							type="filled"
							class="ml-4"
							icon-pack="feather"
							icon="icon-download"
							size="small"
							:disabled="
								loadingExcel || loadingPdf || totalRecords === 0
							"
							@click="() => download('pdf')"
							>{{ loadingPdf ? '' : 'PDF' }}
							<clip-loader
								v-if="loadingPdf"
								size="12px"
								color="#fff"
								class="ml-3"
								:loading="loadingPdf"
							></clip-loader
						></vs-button>
						<vs-button
							color="primary"
							class="ml-4 mr-4"
							type="filled"
							size="small"
							icon-pack="feather"
							icon="icon-download"
							:disabled="
								loadingExcel || loadingPdf || totalRecords === 0
							"
							@click="() => download('excel')"
							>{{ loadingExcel ? '' : 'EXCEL' }}
							<clip-loader
								v-if="loadingExcel"
								size="12px"
								color="#fff"
								class="ml-3"
								:loading="loadingExcel"
							></clip-loader
						></vs-button>
					</div>
				</div>
			</div>
		</div>
	</vs-card>
</template>

<script>
import { format, startOfMonth, addDays, startOfDay } from 'date-fns';
import { ptBR } from 'vuejs-datepicker/dist/locale';
import Datepicker from 'vuejs-datepicker';
import tableMixin from '../../mixins/table';
import {
	formatMoney,
	formatIdentity,
	formatDate,
	formatDateAndTime,
	formatAccount,
	gerarDocPdf,
	gerarTablePdf,
	gerarDocInfo,
	salvarDocPdf,
  formatAmericanMoney,
} from '../../utils/index';
import { excelGenerator } from '../../utils/excelGenerator';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';

export default {
	name: 'Listagem',
	components: { Datepicker, ClipLoader },
	mixins: [tableMixin],
	data() {
		return {
			total: 0,
			filters: [],
			title: process.env.VUE_APP_TITLE,
			startedAt: startOfMonth(new Date()),
			finishedAt: new Date(),
			timeOut: null,
			ptBR: ptBR,
			columns: [
				{
					label: 'Data de Efetivação',
					field: 'effective_at',
				},
				{
					label: 'Origem',
					field: 'provider',
					filterOptions: {
						enabled: true,
						placeholder: 'Pesquisar Origem',
					},
				},
				{
					label: 'CPF/CNPJ',
					field: 'identity',
					filterOptions: {
						enabled: true,
						placeholder: 'Pesquisar CPF/CNPJ',
					},
				},
				{
					label: 'Conta',
					field: 'account',
					filterOptions: {
						enabled: true,
						placeholder: 'Pesquisar Conta',
					},
				},
				{
					label: 'Descrição',
					field: 'description',
				},
				{
					label: 'Valor',
					field: 'amount',
					width: '100px',
				},
			],
			json_fields: {
				Data: 'effective_at',
				Origem: 'provider',
				Destino: 'receiver',
				'CPF/CNPJ': 'identity',
				Conta: 'account',
				Descrição: 'description',
				Valor: 'amount',
			},
			allDatas: null,
			loading: false,
			loadingExcel: false,
			loadingPdf: false,
			totalSum: 0,
		};
	},
	computed: {
		endpoint() {
			// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			this.filters = [];
			// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			this.filters = JSON.parse(sessionStorage.getItem('/revenue-dash'));

			this.startedAt &&
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				this.filters.push({
					field: 'effective_at',
					operator: 'gte',
					value: this.startedAt,
				});

			this.finishedAt &&
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				this.filters.push({
					field: 'effective_at',
					operator: 'lt',
					value: addDays(startOfDay(this.finishedAt), 1),
				});

			this.status &&
				// eslint-disable-next-line vue/no-side-effects-in-computed-properties
				this.filters.push({
					field: 'status',
					operator: 'eq',
					value: this.status,
				});

			return {
				baseUrl: '/dashboard/dashboard/revenue/detail',
				params: {
					orders: {
						effective_at: 'desc',
					},
					filters: this.filters,
				},
			};
		},
	},
	async created() {
		await this.totalizer();
	},
	methods: {
		format,
		formatMoney,
		formatIdentity,
		formatDate,
		formatAccount,
		changeFilter() {
			this.$vs.loading();
			if (this.timeOut != null) {
				clearTimeout(this.timeOut);
			}
			this.page = 1;
			this.$refs['my-table'].resetTable();
			this.reloadItems().then(() => this.$vs.loading.close());
			this.totalizer();
		},
		async totalizer() {
			this.filters = [];
			this.filters = JSON.parse(sessionStorage.getItem('/revenue-dash'));

			this.startedAt &&
				this.filters.push({
					field: 'effective_at',
					operator: 'gte',
					value: this.startedAt,
				});

			this.finishedAt &&
				this.filters.push({
					field: 'effective_at',
					operator: 'lt',
					value: addDays(startOfDay(this.finishedAt), 1),
				});

			this.status &&
				this.filters.push({
					field: 'status',
					operator: 'eq',
					value: this.status,
				});

			try {
				const totalizer = await this.$http.get(
					`/dashboard/dashboard/revenue/detail`,
					{
						params: {
							filters: this.filters,
						},
					}
				);
				this.totalSum = totalizer.data.total_sum;
			} catch (err) {
				console.log(err);
			}
		},
		async download(type) {
			if (type === 'pdf') {
				this.loadingPdf = true;
			} else if (type === 'excel') {
				this.loadingExcel = true;
			}

			try {
				const { url } = await this.createURL({
					limit: this.totalRecords,
					page: 1,
				});

				const { data } = await this.$http.get(url, {
					params: {
						orders: {
							effective_at: 'asc',
						},
						filters: this.filters,
						limit: this.totalRecords,
					},
				});
				this.total = data?.total_sum;
				let result = await data.data.map(row => {
					const item = {};
					item.effective_at = formatDateAndTime(row.effective_at);
					item.provider = row.provider;
					item.identity = formatIdentity(row.identity);
					item.account = formatAccount(row.account);
					item.description = row.description;
					item.amount_pdf = 'R$ ' + formatMoney(row.amount);
					item.amount_excel = parseFloat(formatAmericanMoney(row.amount));

					return item;
				});
				this.allDatas = await result;

				if (type === 'pdf') {
					this.gerarPDF();
				} else if (type === 'excel') {
					this.gerarExcel();
				}
			} catch (err) {
				console.log(err);
				this.loadingExcel = false;
				this.loadingPdf = false;
			}
		},
		async gerarPDF() {
			const columns = [
				{ title: 'Data', dataKey: 'effective_at' },
				{ title: 'Origem', dataKey: 'provider' },
				{ title: 'CPF/CNPJ', dataKey: 'identity' },
				{ title: 'Conta', dataKey: 'account' },
				{ title: 'Descrição', dataKey: 'description' },
				{ title: 'Valor', dataKey: 'amount_pdf' },
			];

			let body = await this.allDatas;

			let doc = gerarDocPdf({});

			doc = gerarTablePdf({
				doc,
				showHead: 'never',
				columnStyles: {
					europe: { halign: 'center' },
					text: { halign: 'left', minCellWidth: 80 },
					s: { halign: 'center' },
				},
				columns: [{ title: 'Title I', dataKey: 'text' }],
				body: [
					{
						text:
							'Receitas no Período de ' +
							format(Date.parse(this.startedAt), 'dd/MM/yyyy') +
							' à ' +
							format(Date.parse(this.finishedAt), 'dd/MM/yyyy'),
					},
				],
			});

			doc = gerarTablePdf({ doc, columns, body });

			doc = gerarTablePdf({
				doc,
				showHead: 'never',
				columnStyles: {
					europe: { halign: 'center' },
					text: { halign: 'right', minCellWidth: 80 },
					s: { halign: 'center' },
				},
				columns: [
					{ title: 'Title I', dataKey: 'text' },
					{ title: 'Title II', dataKey: 'valor' },
				],
				body: [
					{
						text: 'Total',
						valor: 'R$ ' + formatMoney(this.total),
					},
				],
			});

			doc = gerarDocInfo({
				doc,
				title: `Receitas - ${process.env.VUE_APP_TITLE}`,
			});

			salvarDocPdf({ doc, filename: 'receitas_' });
			this.loadingPdf = false;
			this.allDatas = null;
		},
		gerarExcel() {
			const adtStyle = {
				font: { bold: true },
				fill: {
					patternType: 'solid',
					fgColor: {
						rgb: 'fff5f5f5',
					},
					bgColor: {
						rgb: 'fff5f5f5',
					},
				},
				border: {
					top: {
						style: 'thin',
						color: { rgb: 'ffcecece' },
					},
					right: {
						style: 'thin',
						color: { rgb: 'ffcecece' },
					},
					bottom: {
						style: 'thin',
						color: { rgb: 'ffcecece' },
					},
					left: {
						style: 'thin',
						color: { rgb: 'ffcecece' },
					},
				},
			};
			let dataRows = [];
			this.allDatas.map(data => { 
				dataRows.push([
					{
						v: data.effective_at || '',
						t: 's'
					},
					{
						v: data.provider || '',
						t: 's'
					},
					{
						v: data.identity || '',
						t: 's'
					},
					{
						v: data.account || '',
						t: 's'
					},
					{
						v: data.description || '',
						t: 's'
					},
					{
						v: data.amount_excel || '',
						t: 'n',
						z: "R$ ##,##,##0.00",
					},
				])
			});
			excelGenerator(
				'Receitas',
				'Receitas',
				'receitas',
				[
					[
						{
							v: `Receitas no Período de ${format(
								Date.parse(this.startedAt),
								'dd/MM/yyyy'
							)} à ${format(
								Date.parse(this.finishedAt),
								'dd/MM/yyyy'
							)}`,
							t: 's',
							s: {
								alignment: { horizontal: 'left' },
								...adtStyle,
							},
						},
					],
				],
				[
					[
						{
							v: `Total:`,
							t: 's',
							s: {
								alignment: { horizontal: 'left' },
								...adtStyle,
							},
						},
						{},
						{},
						{},
						{},
						{
							v: `R$ ${formatMoney(this.total)}`,
							t: 's',
							s: {
								alignment: { horizontal: 'right' },
								...adtStyle,
							},
						},
					],
				],
				[
					'Data',
					'Origem',
					'CPF/CNPJ',
					'Conta',
					'Descrição',
					'Valor',
				],
				dataRows
			);

			this.loadingExcel = false;
			dataRows = null;
		},
	},
};
</script>
